/* ==========================================================================
   Header > Client > Tooltip
   ========================================================================== */

const $ = require('jquery');
const tippy = require('tippy.js');
const { setCookie } = require('./cookie');

const tooltips = [
    ['.popover-phone', true, '', 'header', true, 'mouseenter'],
    ['#Header-popover-cert0', false, '#Header-cert0', 'header', 'true', 'mouseenter'],
    ['#Header-popover-cert1', false, '#Header-cert1', 'header', 'true', 'mouseenter'],
    ['#Header-popover-user', false, '#Header-user-logged', 'user', 'true', 'mouseenter'],
    ['#list-language', false, '#languageDropdown', 'languages', 'false', 'click'],
    ['#list-currency', false, '#currencyDropdown', 'currencies', 'false', 'click']
];

function initTooltips() {
    tooltips.forEach(element => {
        const tippySelector = element[0];
        const tippyTitle = element[1];
        const tippytemplateId = element[2];
        const tippyTheme = element[3];
        const htmlElementExists = element[1] === false && $(element[2]).length;
        const useTitle = element[1];
        const tippyArrow = element[4];
        const tippyTrigger = element[5];
        if (htmlElementExists || useTitle) {
            let tippyConfig = {};
            if (tippySelector === '#Header-popover-user') {
                tippyConfig = {
                    delay: 0,
                    arrow: tippyArrow,
                    arrowType: 'sharp',
                    duration: 0,
                    animation: 'scale',
                    placement: 'bottom',
                    theme: `light base ${tippyTheme}`,
                    allowTitleHTML: tippyTitle,
                    maxWidth: '300px',
                    interactive: true,
                    trigger: tippyTrigger,
                    html: tippytemplateId,
                    onShown(instance) {
                        const $buttonLogout = $(instance.popper).find('.js-logout');
                        if ($buttonLogout.length) {
                            $buttonLogout.on('click', e => {
                                const urlLogout = $(e.currentTarget).data('urlLogout');
                                const sessionCode = $(e.currentTarget).data('sessionCode');
                                if (urlLogout && sessionCode) {
                                    $.ajax({
                                        complete: xhr => {
                                            if (xhr.status === 200) {
                                                if (window.googleyolo) {
                                                    window.googleyolo
                                                        .disableAutoSignIn()
                                                        .then(
                                                            () => {
                                                                // Do nothing
                                                            },
                                                            () => {
                                                                // Error, write cookie to disable onetap
                                                                setCookie('ck_disable_onetap', 'true', 1 / 24);
                                                            }
                                                        )
                                                        .finally(() => {
                                                            window.parent.location.reload(true);
                                                        });
                                                } else {
                                                    // Just disable One Tap by cookie and reload page
                                                    setCookie('ck_disable_onetap', 'true', 1 / 24);
                                                    window.parent.location.reload(true);
                                                }
                                            }
                                        },
                                        crossDomain: true,
                                        data: {
                                            sessionCode
                                        },
                                        dataType: 'jsonp',
                                        url: urlLogout
                                    });
                                }
                            });
                        }
                    }
                };
            } else {
                tippyConfig = {
                    delay: 0,
                    arrow: tippyArrow,
                    arrowType: 'sharp',
                    duration: 0,
                    animation: 'scale',
                    placement: 'bottom',
                    theme: `light base ${tippyTheme}`,
                    allowTitleHTML: tippyTitle,
                    maxWidth: '300px',
                    interactive: true,
                    trigger: tippyTrigger,
                    html: tippytemplateId
                };
            }

            tippy(`.Header ${tippySelector}`, tippyConfig);
        }
    });
}

module.exports = {
    initTooltips
};
